import React from 'react';
import './Logo.scss';

interface LogoProps {
    href: string;
    onClick?: () => void;
    logoUrl?: string;
}

const Logo: React.FC<LogoProps> = ({ href, onClick, logoUrl }) => {
    const isStbMaxPage = typeof window !== 'undefined' && window.location.pathname === '/stb-hbomax';
    return (
        <a 
            href={href} 
            onClick={onClick} 
            className="navbar-brand"
            style={isStbMaxPage ? { pointerEvents: 'none', cursor: 'default' } : undefined}
        >
            {logoUrl && <img src={logoUrl} className="nowtv-logo" alt="Now TV Logo" />}
        </a>
    );
};

export default Logo;
